var map = {
	"./BeancurdCube.vue": "17ea",
	"./Button.vue": "2a7d",
	"./CheckProtocol.vue": "2bde",
	"./CustomerLaunch.vue": "96f6",
	"./GoodsCategory.vue": "3b4f",
	"./IconSetting.vue": "ad91",
	"./IconTitle.vue": "ebf7",
	"./ImageSwiper.vue": "574a",
	"./LimitedSpecial.vue": "bde2",
	"./PageButton.vue": "b30d",
	"./PanelBox.vue": "19e0",
	"./Picture.vue": "57f4",
	"./ProtocolListSetting.vue": "efb6",
	"./ReceiveAwards.vue": "8d3b",
	"./RecommendSetting.vue": "6d0d",
	"./SpecialOffer.vue": "61f1",
	"./Swiper.vue": "8419",
	"./TextSetting.vue": "bd25",
	"./Toast/index.vue": "7e2d",
	"./WheelPrize.vue": "a955",
	"./WordToHtml.vue": "4c45",
	"./download.vue": "6d45",
	"./msgcode.vue": "d02b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bff8";